import React, { useRef } from 'react'
import PropTypes from 'prop-types'

import { collapsable } from '@aok/accordion'
import { ArrowSmallDown } from '@aok/icon-functional'
import { Link } from '@aok/ui-elements'

import { formatDateFromString } from '../../../utils/DateUtils'
import defaultProps from '../../../utils/propTypes/defaultProps'

import SmallContentContainer from '../../_layouts/SmallContentContainer/SmallContentContainer'
import AllroundContainer from '../../_layouts/AllroundContainer'

const T006 = ({ releaseDate, nextUpdate, sources }) => {
  const collapsableRef = useRef(null)
  const collapsableRefTarget = useRef(null)

  return (
    <AllroundContainer dataTrackingName="T006">
      <SmallContentContainer isArticleContainer>
        <div className="flex justify-start items-center">
          {sources && (
            <span className="toggle-sources" ref={collapsableRef}>
              <Link
                className="text-293033"
                onClick={() => collapsable(collapsableRef.current, collapsableRefTarget.current)}
                title="Quellen"
                iconPosition="right"
                icon={<ArrowSmallDown className="fill-current mb-2 w-full h-auto" />}
                theme="secondary"
              />
            </span>
          )}
          {sources && releaseDate && <div className="h-24 border-r-2 border-dfe3e6 ml-28 mr-24" />}

          <div className="flex flex-col items-start 840:flex-row">
            {releaseDate && (
              <>
                <span className="text-828b91 text-14 leading-20">{`Aktualisiert: ${formatDateFromString(
                  releaseDate
                )}`}</span>
              </>
            )}

            {/* Only for IQWIG usage of T006 */}
            {nextUpdate && (
              <span className="text-828b91 text-14 leading-20 840:ml-24">{`Nächste geplante Aktualisierung: ${nextUpdate}`}</span>
            )}
          </div>
        </div>

        {sources && (
          <div
            hidden
            className="collapseContent h-0 overflow-hidden transition-all duration-200 ease-out"
            ref={collapsableRefTarget}
          >
            <div dangerouslySetInnerHTML={{ __html: sources }} className="articleSources pt-16 1000:pt-24" />
          </div>
        )}
      </SmallContentContainer>
    </AllroundContainer>
  )
}

T006.propTypes = {
  releaseDate: PropTypes.string,
  sources: PropTypes.string,
}

T006.defaultProps = {
  sources: defaultProps.DESCRIPTION_RICH,
}

export default T006
